'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.rewards = void 0;
var adapter_1 = require("../adapter");
var Rewards = /** @class */ (function () {
    function Rewards() {
    }
    /**
     * Get all rewards based on a filter.
     */
    Rewards.prototype.getAll = function (params) {
        return adapter_1.adapter.rewards.getAll(params);
    };
    Rewards.prototype.getShopRewards = function (params) {
        return adapter_1.adapter.rewards.getShopRewards(params);
    };
    /**
     * Exchange echoes or tokens for free spins, money bonuses or tries for metagames.
     */
    Rewards.prototype.claimReward = function (params) {
        return adapter_1.adapter.rewards.claimReward(params);
    };
    /**
     * Get user's rewards.
     */
    Rewards.prototype.getUserRewards = function (params) {
        return adapter_1.adapter.rewards.getUserRewards(params);
    };
    Rewards.prototype.history = function (params) {
        return adapter_1.adapter.rewards.history(params);
    };
    Rewards.prototype.newlyAwardedTokens = function () {
        return adapter_1.adapter.rewards.newlyAwardedTokens();
    };
    Rewards.prototype.buyTokens = function (params) {
        return adapter_1.adapter.rewards.buyTokens(params);
    };
    return Rewards;
}());
exports.rewards = new Rewards();
